import { Img, Heading, Button } from "../../components";
import SelectBox from "../../components/SelectBox"
import { ReactTable } from "../../components/ReactTable";
import { createColumnHelper } from "@tanstack/react-table";
import React from "react";

const dropDownOptions = [
  { label: "Option1", value: "option1" },
  { label: "Option2", value: "option2" },
  { label: "Option3", value: "option3" },
];
const table1Data = [
  {
    portfolioHeader: "Group1",
    mvHeader: "Content",
    ytdReturnHeader: "Content",
    volatilityHeader: "Content",
    positionsHeader: "Content",
    statusHeader: "Status",
    uploadDateHeader: "MM/DD/YY",
    uploadByHeader: "Name",
    lastModifiedHeader: "MM/DD/YY",
    modifiedByHeader: "Name",
  },
  {
    portfolioHeader: "Portfolio1",
    mvHeader: "Content",
    ytdReturnHeader: "Content",
    volatilityHeader: "Content",
    positionsHeader: "Content",
    statusHeader: "Status",
    uploadDateHeader: "MM/DD/YY",
    uploadByHeader: "Name",
    lastModifiedHeader: "MM/DD/YY",
    modifiedByHeader: "Name",
  },
  {
    portfolioHeader: "Portfolio2",
    mvHeader: "Content",
    ytdReturnHeader: "Content",
    volatilityHeader: "Content",
    positionsHeader: "Content",
    statusHeader: "Status",
    uploadDateHeader: "MM/DD/YY",
    uploadByHeader: "Name",
    lastModifiedHeader: "MM/DD/YY",
    modifiedByHeader: "Name",
  },
  {
    portfolioHeader: "Group2",
    mvHeader: "Content",
    ytdReturnHeader: "Content",
    volatilityHeader: "Content",
    positionsHeader: "Content",
    statusHeader: "Status",
    uploadDateHeader: "MM/DD/YY",
    uploadByHeader: "Name",
    lastModifiedHeader: "MM/DD/YY",
    modifiedByHeader: "Name",
  },
  {
    portfolioHeader: "Portfolio1",
    mvHeader: "Content",
    ytdReturnHeader: "Content",
    volatilityHeader: "Content",
    positionsHeader: "Content",
    statusHeader: "Status",
    uploadDateHeader: "MM/DD/YY",
    uploadByHeader: "Name",
    lastModifiedHeader: "MM/DD/YY",
    modifiedByHeader: "Name",
  },
  {
    portfolioHeader: "Portfolio2",
    mvHeader: "Content",
    ytdReturnHeader: "Content",
    volatilityHeader: "Content",
    positionsHeader: "Content",
    statusHeader: "Status",
    uploadDateHeader: "MM/DD/YY",
    uploadByHeader: "Name",
    lastModifiedHeader: "MM/DD/YY",
    modifiedByHeader: "Name",
  },
];

export default function PortfoliosEditSection() {
  const table1Columns = React.useMemo(() => {
    const table1ColumnHelper = createColumnHelper();
    return [
      table1ColumnHelper.accessor("portfolioHeader", {
        cell: (info) => (
          <div
          className={`flex items-center gap-3.5 ${
            info.getValue().startsWith("Portfolio") ? "pl-4" : ""
          }`}
        >
            <Img src="images/img_television.svg" alt="Television Image" className=" " />
            <Heading size="headingxs" as="p" className="items-center text-[12px] font-bold text-white-a700">
              {info.getValue()}
            </Heading>
          </div>
        ),
        header: (info) => (
          <Heading
            size="headingxs"
            as="h2"
            className="pb-[22px] pl-[34px] text-left text-[12px] font-bold text-white-a700 sm:pb-5 sm:pl-5"
          >
            Portfolios
          </Heading>
        ),
        meta: { width: "158px" },
      }),
      table1ColumnHelper.accessor("mvHeader", {
        cell: (info) => (
          <Heading size="headingxs" as="p" className="text-[12px] font-medium text-white-a700">
            {info.getValue()}
          </Heading>
        ),
        header: (info) => (
          <Heading
            size="headingxs"
            as="h3"
            className="pb-[22px] text-left text-[12px] font-bold text-white-a700 sm:pb-5"
          >
            MV
          </Heading>
        ),
        meta: { width: "114px" },
      }),
      table1ColumnHelper.accessor("ytdReturnHeader", {
        cell: (info) => (
          <Heading size="headingxs" as="p" className="text-[12px] font-medium text-white-a700">
            {info.getValue()}
          </Heading>
        ),
        header: (info) => (
          <Heading
            size="headingxs"
            as="h4"
            className="pb-[22px] text-left text-[12px] font-bold text-white-a700 sm:pb-5"
          >
            YTD Return
          </Heading>
        ),
        meta: { width: "114px" },
      }),
      table1ColumnHelper.accessor("volatilityHeader", {
        cell: (info) => (
          <Heading size="headingxs" as="p" className="text-[12px] font-medium text-white-a700">
            {info.getValue()}
          </Heading>
        ),
        header: (info) => (
          <Heading
            size="headingxs"
            as="h5"
            className="pb-[22px] text-left text-[12px] font-bold text-white-a700 sm:pb-5"
          >
            Vol
          </Heading>
        ),
        meta: { width: "114px" },
      }),
      table1ColumnHelper.accessor("positionsHeader", {
        cell: (info) => (
          <Heading size="headingxs" as="p" className="text-[12px] font-medium text-white-a700">
            {info.getValue()}
          </Heading>
        ),
        header: (info) => (
          <Heading
            size="headingxs"
            as="h6"
            className="pb-[22px] text-left text-[12px] font-bold text-white-a700 sm:pb-5"
          >
            # Positions
          </Heading>
        ),
        meta: { width: "114px" },
      }),
      table1ColumnHelper.accessor("statusHeader", {
        cell: (info) => (
          <Heading size="headingxs" as="p" className="text-[12px] font-medium text-white-a700">
            {info.getValue()}
          </Heading>
        ),
        header: (info) => (
          <Heading
            size="headingxs"
            as="p"
            className="pb-[22px] text-left text-[12px] font-bold text-white-a700 sm:pb-5"
          >
            Status
          </Heading>
        ),
        meta: { width: "84px" },
      }),
      table1ColumnHelper.accessor("reportsHeader", {
        cell: (info) => (
          <div className="flex flex-1">
            <SelectBox
              shape="square"
              indicator={<Img src="images/img_arrowdown.svg" alt="Arrow Down" className="h-[16px] w-[16px]" />}
              name="Reports Dropdown"
              placeholder={`List Reports`}
              options={dropDownOptions}
              className="mt-3 w-[82%] gap-[26px] px-2.5 font-medium text-white-a700"
            />
          </div>
        ),
        header: (info) => (
          <Heading
            size="headingxs"
            as="p"
            className="pb-[22px] text-left text-[12px] font-bold text-white-a700 sm:pb-5"
          >
            Reports
          </Heading>
        ),
        meta: { width: "144px" },
      }),
      table1ColumnHelper.accessor("uploadDateHeader", {
        cell: (info) => (
          <Heading size="headingxs" as="p" className="text-[12px] font-medium text-white-a700">
            {info.getValue()}
          </Heading>
        ),
        header: (info) => (
          <Heading
            size="headingxs"
            as="p"
            className="pb-[22px] text-left text-[12px] font-bold text-white-a700 sm:pb-5"
          >
            Upload Date
          </Heading>
        ),
        meta: { width: "114px" },
      }),
      table1ColumnHelper.accessor("uploadByHeader", {
        cell: (info) => (
          <Heading size="headingxs" as="p" className="text-[12px] font-medium text-white-a700">
            {info.getValue()}
          </Heading>
        ),
        header: (info) => (
          <Heading
            size="headingxs"
            as="p"
            className="pb-[22px] text-left text-[12px] font-bold text-white-a700 sm:pb-5"
          >
            Upload By
          </Heading>
        ),
        meta: { width: "94px" },
      }),
      table1ColumnHelper.accessor("lastModifiedHeader", {
        cell: (info) => (
          <Heading size="headingxs" as="p" className="text-[12px] font-medium text-white-a700">
            {info.getValue()}
          </Heading>
        ),
        header: (info) => (
          <Heading
            size="headingxs"
            as="p"
            className="pb-[22px] text-left text-[12px] font-bold text-white-a700 sm:pb-5"
          >
            Last Modified
          </Heading>
        ),
        meta: { width: "114px" },
      }),
      table1ColumnHelper.accessor("modifiedByHeader", {
        cell: (info) => (
          <Heading size="headingxs" as="p" className="text-[12px] font-medium text-white-a700">
            {info.getValue()}
          </Heading>
        ),
        header: (info) => (
          <Heading
            size="headingxs"
            as="p"
            className="pb-[22px] text-left text-[12px] font-bold text-white-a700 sm:pb-5"
          >
            Modified By
          </Heading>
        ),
        meta: { width: "90px" },
      }),
    ];
  }, []);

  return (
    <>
      {/* portfolios edit section */}
      <div className="flex flex-col items-center gap-1.5 self-stretch">
        <div className="flex w-[86%] flex-col items-center gap-[18px] md:w-full md:px-5">
          <div className="container-xs flex flex-col items-center px-14 md:px-5">
            <Heading
              size="text2xl"
              as="h1"
              className="text-[44px] font-medium text-white-a700 md:text-[40px] sm:text-[34px]"
            >
              Portfolios.
            </Heading>
          </div>
          <div className="mb-[158px] flex flex-col items-center gap-7 self-stretch">
            <div className="container-xs md:px-5">
              <div className="flex justify-center sm:flex-col">
                <Button color="green_A700" shape="square" className="min-w-[114px] px-5">
                  Select All
                </Button>
                <div className="flex flex-1 justify-end gap-6 sm:self-stretch">
                  <Button
                    color="white_A700"
                    shape="square"
                    leftIcon={
                      <Img
                        src="images/img_materialsymbolsuploadsharp.svg"
                        alt="Material-symbols:upload-sharp"
                        className="h-[20px] w-[20px]"
                      />
                    }
                    className="min-w-[176px] gap-2 px-3"
                  >
                    Upload Portfolio
                  </Button>
                  <Button color="red_500" shape="square" className="min-w-[114px] px-8 sm:px-5">
                    Delete
                  </Button>
                </div>
              </div>
            </div>
            <ReactTable
              size="xs"
              bodyProps={{ className: "" }}
              headerProps={{ className: "border-white-a700 border-b border-solid" }}
              cellProps={{ className: "border-white-a700 border-b border-solid" }}
              className="self-stretch md:block md:overflow-x-auto md:whitespace-nowrap"
              columns={table1Columns}
              data={table1Data}
            />
            <div className="container-xs md:px-5">
              <div className="flex justify-center md:flex-col">
                <Button
                  variant="outline"
                  shape="square"
                  leftIcon={
                    <Img src="images/img_icbaselineplus.svg" alt="Ic:baseline-plus" className="h-[22px] w-[22px]" />
                  }
                  className="min-w-[140px] gap-2 !border px-[11px]"
                >
                  New Group
                </Button>
                <div className="flex flex-1 justify-end gap-[25px] md:self-stretch">
                  <Button shape="square" className="min-w-[242px] px-3 !text-indigo-a700">
                    Multiple Portfolio Dashboard
                  </Button>
                  <Button color="indigo_A700" shape="square" className="min-w-[228px] px-3">
                    Single Portfolio Dashboard
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="container-xs flex flex-col items-start md:px-5">
          <div className="flex items-center gap-[22px] bg-gray-900_02 p-1">
            <Heading size="texts" as="p" className="self-end text-[14px] font-medium tracking-[-0.28px] text-gray-400">
              Powered by
            </Heading>
            <Img src="images/img_settings.svg" alt="Settings Image" className="h-[16px] object-contain" />
          </div>
        </div>
      </div>
    </>
  );
}
